import React from "react";

// Chakra imports
import { Flex, Text } from "@chakra-ui/react";

// Assets
import banner from "assets/img/nfts/NftBanner1.png";

export default function Banner() {
  // Chakra Color Mode
  return (
    <Flex
      direction='column'
      bgImage={banner}
      bgSize='cover'
      py={{ base: "30px", md: "52px" }}
      px={{ base: "30px", md: "52px" }}
      borderRadius='30px'>
      <Text
        fontSize={{ base: "24px", md: "30px" }}
        color='white'
        mb='14px'
        maxW={{
          base: "100%",
          md: "64%",
          lg: "46%",
          xl: "70%",
          "2xl": "50%",
          "3xl": "42%",
        }}
        fontWeight='700'
        lineHeight={{ base: "32px", md: "42px" }}>
        Suivez l'activité de vos <br></br>managers au fil de l’eau
      </Text>
      <Text
        fontSize='md'
        color='#E3DAFF'
        maxW={{
          base: "100%",
          md: "64%",
          lg: "40%",
          xl: "56%",
          "2xl": "46%",
          "3xl": "34%",
        }}
        fontWeight='500'
        
        lineHeight='28px'>
        Managers actifs, scénarios complétés et comportements exercés par vos managers
      </Text>
      <Flex align='center'>
        
        
      </Flex>
    </Flex>
  );
}
